'use client';

import { useState, useEffect } from 'react';
import CountUp from 'react-countup';

import { Container, Number, Title } from './counter.elements';
import { Rating } from '@mantine/core';

const Counter = ({ title, value, decimals, rating }) => {
  const [showStars, setShowStars] = useState(false);

  useEffect(() => {
    if (rating) {
      setTimeout(() => {
        setShowStars(true);
      }, 4000);
    }
  }, []);

  return (
    <Container $rating={rating}>
      <Title>{title}</Title>
      <Number $showStars={showStars}>
        <Rating
          id={`counter-rating-${String(title || '').toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
          defaultValue={value || 0}
          fractions={10}
          readOnly
          size="lg"
        />
        <CountUp start={0} end={value} duration={2.75} decimals={decimals || 0} />
      </Number>
    </Container>
  );
};

export { Counter };
